module.exports = __webpack_public_path__ + "static/media/subscription_icon_active.94f9d313.svg";